import { z } from "zod";

const notificationReceiverSchema = z.object({
    id: z.string().optional(),
    notificationId: z.string(),
    receiverId: z.number(),
    receiverName: z.string(),
    confirmStatus: z.string(),
    confirmTime:z.string().optional(),
    readTime: z.string(),
    receiveTime:z.string().optional(),
});

export type notificationReceiverSchema  = z.infer<typeof notificationSchema>;

export const notificationSchema = z.object({
      id: z.string().optional(),
        notificationType: z.string().min(1,"请选择通知类型"),
        priority:z.string().min(1,"请选择优先级"),
      notificationSn: z.string().optional(),
      title: z.string().optional(),
      content: z.string().min(1,"请输入内容"),
      businessType: z.string().optional(),
      businessId: z.string().optional(),
      senderId: z.string(),
      expireTime: z.string().min(1,"请选择过期时间"),
      remark: z.string().optional(),
      receiverIds:z.array(z.string()).min(1,"请选择接收人")
  })

export type notificationSchema = z.infer<typeof notificationSchema>;
